import {UnitGroupModel} from './unit-group/unit-group.model';
import {UnitTypeModel} from '../unit-type/unit-type-list/unit-type.model';

export class UnitModel {
  id: number;
  project_id: number;
  unit_model_id: number;
  ownerId: number;
  region_id: number;
  unit_status_id: number;
  name: string;
  hw_type: string;
  hw_model: string;
  mechanical_lock_code_display: boolean;
  mechanical_lock_code: string;
  hw_id: string;
  phone: string;
  warehouse_number: string;
  admin_id: number;
  integrator_id: number;
  rent_to_integrator_id: number;
  plate_number: string;
  registration_number: string;
  color: string;
  html_color: string;
  color_name: string;
  editable_by_integrator: boolean;
  showInApplication: boolean;
  mileage: number;
  activeExecutorBillingId: number;
  unitGroups: UnitGroupModel[];
  unitType: UnitTypeModel;
  model_access_rights: {
    read: boolean;
    update: boolean;
    delete: boolean;
    sendCommand: boolean;
    changeStatus: boolean;
    readUnitLog: boolean;
  };
}

